import React, { Component } from 'react';
import RatingStars5 from "../../../common/ratingStars5";
import DurationInput from "../../../common/durationInput";
import InputText from "../../../pages/pageParts/inputForms/inputText";

import '../../../index.scss';

class IndividualCharacteristics extends Component {
    constructor(props) {
        super(props);
        this.onCompetitorChange = this.onCompetitorChange.bind(this);
        this.receiveRating = this.receiveRating.bind(this);
        this.state = {
            loading: false,
            teamdisplayname: this.props.teamdisplayname,
            competitor: this.props.competitor,
            partner: this.props.partner,
            content: this.props.content ? JSON.parse(this.props.content) : {},
            options: this.props.options,
            rEvent: this.props.rEvent,
            tBallot: this.props.tBallot,
            tooltipOpen: {}
        }

        this.headerStyle = {
            fontWeight: "600",
            fontSize: "22px",
            lineHeight: "30px",
            color: "#355681",
            padding: "6px 0px 0px 0px",
            margin:  "6px 0px 0px 0px",
            display: "block"
            }

        this.rankStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "0px 10px 0px 10px",
            margin: "10px 0px 0px 0px",
            backgroundColor: '#dddddd'
            }

        this.pointStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "0px 10px 0px 10px",
            margin: "0px 0px 10px 0px",
            backgroundColor: '#dddddd'
            }
    
        this.rankColStyle = {
            }
                
        this.labelStyle = {fontSize: "16px"};
        this.groupLabelStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "0px 10px 0px 10px",
            margin: "0px 0px 10px 0px",
            backgroundColor: '#dddddd'
        };

    }

    updateContents(rankOnly) {

        this.props.updateContents(this.state.competitor, JSON.stringify(this.state.content), rankOnly)
        if (this.state.partner) {
            this.props.updateContents(this.state.partner, JSON.stringify(this.state.content), rankOnly);
        }
    }

    onCompetitorChange(evt) {
        var id = evt.target.id
        if (id.startsWith("comments")) id = "comments";
        if (id.startsWith("topic")) id = "topic";
        if (id.startsWith("chr_comments")) id = id.substring(0,16);
        const val = evt.target.value

        this.setState(
            (s) => ({ content: { ...s.content, [id]: val } }),
            () => this.updateContents(false)
        );

        this.updateContents(false);
    }

    receiveRating = (id, rating) => {
        this.setState(
            (s) => {
                const nextContent = { ...s.content, [id]: rating };
                const nextPoints = this.state.options.filter(opt => opt.render !== false).reduce(
                (a, b) => a + (nextContent[b.key] || 0),
                0
                );
                nextContent.points = nextPoints;
                return { content: nextContent };
            },
            () => this.updateContents(false)
        );

        this.updateContents(false);
    };

    componentDidMount() {}

    componentDidUpdate(prevProps) {}

    handleRankChange = (e) => {
        const value = e.target.value === '' ? null : Number(e.target.value);
        this.setState(
            (s) => ({
            content: {
                ...s.content,
                rank: value,
            },
            }),
            () => this.updateContents(true)
        );
    };

    toggleToolTip(key) {
        const tooltipOpen = this.state.tooltipOpen;
        if (!tooltipOpen[key]) tooltipOpen[key] = false;
        tooltipOpen[key] = !tooltipOpen[key];
        this.setState({tooltipOpen});
    }

    render(){
        if (this.state.loading) { return null; }
        const {competitor, options, content, teamdisplayname} = this.state;
        const space = 3;
        const charCount = content.comments ? content.comments.length : 0;
        
        return (
            <div className="card">
                <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                    <div className="row">
                        <div className="col-12">
                            <label style={this.headerStyle}>{teamdisplayname ? teamdisplayname : competitor.displayname}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <span style={{fontSize: "18px"}}>Topic:</span>
                            <input style={{margin: "10px", width: "85%", height: "34px", fontSize: "18px"}} type='text' id={'topic_'+competitor.userId} defaultValue={content.topic} onChange={this.onCompetitorChange} placeholder="" readOnly={this.props.readOnly} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4">
                            <span style={{fontSize: "18px"}}>Rank:</span>
                            <select
                                id={`rank_${this.state.competitor.userId}`}
                                className="form-control form-control-sm d-inline-block"
                                style={{ width: 'auto', margin: '10px', height: '34px', fontSize: '18px' }}
                                value={content.rank != null ? content.rank : ''}
                                onChange={this.handleRankChange}
                                disabled={this.props.readOnly}
                                aria-label="Select rank"
                                >
                                <option value="">-- Select --</option>
                                {Array.from(
                                    { length: (this.props.rankCount) || 0 },
                                    (_, i) => i + 1
                                ).map((r) => (
                                    <option key={r} value={r}>
                                    {r}
                                    {r === 1 ? ' - Strongest' : ''}
                                    {r === this.props.rankCount ? ' - Weakest' : ''}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-4">
                            <span style={{fontSize: "18px"}}>Duration:</span>
                            <DurationInput
                            id={"duration_" + competitor.userId}
                            valueSeconds={content.speechDurationSec || 0}
                            readOnly={this.props.readOnly}
                            onChange={(totalSeconds) => {
                                this.setState(
                                (s) => ({
                                    content: { ...s.content, speechDurationSec: totalSeconds }
                                }),
                                () => this.updateContents(false)
                                );
                            }}
                            />
                        </div>
                        <div className="col-4">
                            <span style={{display: "inline-block", fontSize: "18px", margin: "10px", height: "34px", padding: "1px 2px"}}>Points: {content.points || 0}</span>
                        </div>
                    </div>

                    <hr style={{paddingTop: "0px", marginTop: "0px"}}/>

                    {options.filter(opt => opt.render !== false).map((optionGroup, index) => {
                        const gkeykey = optionGroup.key+'_'+competitor.userId;
                        return (
                            <>
                            <div className="row" style={this.groupLabelStyle}>
                                <div className="col-12 col-md-6">
                                    <label id={`ltt_${gkeykey}`}>{optionGroup.title}</label>
                                </div>
                                <div className="col-12 col-md-3">
                                    Based on Speech Reference Guide:
                                </div>
                                <div className="col-12 col-md-3">
                                    Speaker Feedback
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-4 col-lg-6 col-xl-6">
                                    <b>{optionGroup.instruction}</b><br/>
                                    <ul>
                                        {optionGroup.bullets.map((bullet, index) => {
                                            return (
                                                <li>{bullet}</li>
                                        )})}
                                    </ul>
                                </div>
                                <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                    <RatingStars5 readOnly={this.props.readOnly} id={gkeykey} space={space} rating={content[optionGroup.key]} receiveRating={(rating) => this.receiveRating(optionGroup.key,rating)}/>
                                </div>
                                <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <InputText id={"chr_comments_"+gkeykey} value={content["chr_comments_"+optionGroup.key]} 
                                    onChange={this.onCompetitorChange} 
                                    placeholder="" readOnly={this.props.readOnly} rows={optionGroup.bullets.length + 1} autoResize />
                                </div>
                            </div>
                            <hr />
                            </>
                        )})
                    }        

                    <hr style={{paddingTop: "0px", margin: "0px"}}/>
                    <div className="row">
                        <div className="col-12">
                            <InputText label="Reason for Ranking and other comments: (It is very helpful to the competitor if you enter at least 100 characters)" id={"comments_"+competitor.userId} value={content.comments} 
                            onChange={this.onCompetitorChange} 
                            labelSuffix={<span className={charCount >= 100 ? "font-success" : "font-danger"}>[{charCount}&nbsp;characters]</span>}
                            placeholder="" readOnly={this.props.readOnly} autoResize />
                        </div>
                    </div>                                                                              
                </div>
            </div>    
        )
    }
}

export default IndividualCharacteristics;



